import axiosInstance from "./axiosInstance";

export interface TourServiceApi {
  additionalServicePublicId?: number | string,
  tourServiceId: number;
  publicId: string | number;
  serviceName: string;
  description: string;
  serviceType: "transport" | "additional";
  isMandatory: boolean;
  isDefaultChecked: boolean;
  isChargeable?: boolean;
  isActive: boolean;
  createdAt: string;
}

export interface TourServiceListResponse {
  items: TourServiceApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface TourServiceListQuery {
  searchText?: string | null;
  serviceName?: string | null;
  serviceType?: string | null;
  isMandatory?: boolean | null;
  isActive?: boolean | null;
  pageNo?: number;
  pageSize?: number;
}


export const getAuthHeader = () => { 
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getActiveTourServices = async (isActive: boolean) => {
  const response = await axiosInstance.get("/TourService", {
    params: {
      isActive,
    },
  });

  return response.data;
  // return {
  //   ...response.data,
  //   items: response.data.items.map((service: TourServiceApi) => ({
  //     ...service,
  //     // Backward compatibility until the API starts returning isChargeable.
  //     isChargeable: service.isChargeable ?? service.serviceType === "additional",
  //   })),
  // };
};

export const getTourServices = async (
  params: TourServiceListQuery
): Promise<TourServiceListResponse> => {
  const res = await axiosInstance.get("/TourService/list", {
    params,
    headers: getAuthHeader(),
  });
  return {
    ...res.data,
    items: res.data.items.map((service: TourServiceApi) => ({
      ...service,
      // Backward compatibility until the API starts returning isChargeable.
      isChargeable: service.isChargeable ?? service.serviceType === "additional",
    })),
  };
};

export interface CreateTourServicePayload {
  serviceName: string;
  description: string;
  serviceType: string;
  isMandatory: boolean;
  isDefaultChecked: boolean;
  isChargeable: boolean;
  isActive: boolean;
  createdBy: number;
}

export const createTourService = async (
  payload: CreateTourServicePayload
) => {
  const res = await axiosInstance.post("/TourService", payload,{
    headers: getAuthHeader(),
  });
  return res.data;
};

export interface UpdateTourServicePayload {
  tourServiceId: number;
  serviceName: string;
  description: string;
  serviceType: string;
  isMandatory: boolean;
  isDefaultChecked: boolean;
  isChargeable: boolean;
  isActive: boolean;
  updatedBy: number;
}

export const updateTourService = async (
  payload: UpdateTourServicePayload
) => {
  const res = await axiosInstance.put(
    `/TourService/${payload.tourServiceId}`,
    payload,{
      headers: getAuthHeader(),
    }
  );
  return res.data;
};
